import { get, isObject } from 'lodash'

export default class Timetable {
  /** @constructor
   * @param {Object} init
   * @property {String} stage
   */
	constructor (init = {}) {
		this.stage = get(init, 'stage') ? init.stage : null
		this.setObject(init)
	}

	setObject (init) {
		if (isObject(init) && !Array.isArray(init)) {
			Object.entries(init).filter(([k, v]) => k !== 'stage')
        .forEach(([k, v]) => {
	this[k] = new DateObj(v)
})
		}
	}
}

class DateObj {
  /** @constructor
   * @param {Object} init
   * @property {Date} date
   * @property {Array} task
   * @property {Array | Object} timetable
   */
	constructor (init = {}) {
		this.date = get(init, 'date') ? init.date : null
		this.task = get(init, 'task') && Array.isArray(init.task) ? init.task.map(el => new Task(el)) : null
		this.timetable = get(init, 'timetable') ? this.setObjectToArray(init.timetable) : null
	}

	setObjectToArray (init) {
		if (isObject(init) && !Array.isArray(init)) {
			return Object.values(init).map(el => new Time(el))
		} else if (Array.isArray(init)) {
			return init.map(el => new Time(el))
		} else return null
	}
}

class Task {
  /** @constructor
   * @param {Object} init
   * @property {String} description
   * @property {String} name
   */
	constructor (init = {}) {
		this.description = get(init, 'description') ? init.description : null
		this.name = get(init, 'name') ? init.name : null
	}
}

class Time {
  /** @constructor
   * @param {Object} init
   * @property {String} action
   * @property {String} info
   * @property {String} time_start
   * @property {String} time_end
   * @property {String} time_start_Moscow
   * @property {String} time_end_Moscow
   */
	constructor (init = {}) {
		this.action = get(init, 'action') ? init.action : null
		this.info = get(init, 'info') ? init.info : null
		this.time_start = get(init, 'time_start') ? init.time_start : null
		this.time_end = get(init, 'time_end') ? init.time_end : null
		this.time_start_Moscow = get(init, 'time_start_Moscow') ? init.time_start_Moscow : null
		this.time_end_Moscow = get(init, 'time_end_Moscow') ? init.time_end_Moscow : null
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/Event/Timetable.js